import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import httpClient from "../../utils/httpClient";

interface RequestDetails {
  ProductId: string;
}

interface SkuInforamtion {
  SkuId: string;
  Name: string;
  Description: string;
}

interface SkuList {
  isLoading: boolean;
  data: {
    Data: SkuInforamtion[];
  };
  error: string | null;
}

const initialState: SkuList = {
  isLoading: true,
  data: {
    Data: [],
  },
  error: null,
};

export const fetchSkuInformationData = createAsyncThunk<any, RequestDetails>(
  "CTSkuInformationSlice/fetchSkuInformationData",
  async (requestDetails, thunkApi) => {
    try {
      const response = await httpClient.post("/product/sku", {
        ProductId: requestDetails.ProductId,
        Action: "info",
      });

      if (response.status != 200 || response.data.Status !== "success") {
        if (response.data.Status == "error") {
          return thunkApi.rejectWithValue(response.data.Message);
        }
      }

      return response.data;
    } catch (error) {
      console.log("🚀 ~ error:", error);
      return thunkApi.rejectWithValue({ message: "Something went wrong!" });
    }
  }
);

const CTSkuInformationSlice = createSlice({
  name: "CTSkuInformationSlice",
  initialState,
  reducers: {
    resetSkuInformationState: (state) => {
      state.isLoading = true;
      state.data = {
        Data: [],
      };
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSkuInformationData.pending, (state) => {
        state.isLoading = true;
        state.data = {
          Data: [],
        };
        state.error = null;
      })
      .addCase(
        fetchSkuInformationData.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.data = action.payload;
          state.error = null;
        }
      )
      .addCase(
        fetchSkuInformationData.rejected,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.data = {
            Data: [],
          };
          state.error = action.payload.message;
        }
      );
  },
});

export const { resetSkuInformationState } = CTSkuInformationSlice.actions;
export default CTSkuInformationSlice.reducer;
